export function formatMoney(value: number | string) {
  value = `${value}`.replace(/\D/g, "");
  value = Number(value);
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value / 100);
}
